package terraultima.web

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json

/**
 * A century, saved.
 *
 * Seed plus the numbers tapped IS the run (see [Run]), so this is the entire persistent state of the
 * game — a few hundred bytes, which fits inside one Telegram `CloudStorage` value with room to
 * spare. There is no server to hold anything else, and nothing else needs holding.
 *
 * `corpus` is the count of events the run was played against. It is not used to refuse a resume —
 * that would throw away someone's century over a content edit — but it is shown when it disagrees,
 * because a replayed choice can land on an option that has since moved, and a player who notices
 * their run drifting deserves to be told why rather than left doubting the game.
 */
@Serializable
data class Save(
    val seed: Int,
    val motive: Int,
    val choices: List<Int> = emptyList(),
    val launched: Boolean = false,
    val finished: Boolean = false,
    val debug: Boolean = false,
    val corpus: Int = 0
)

object Store {

    private const val KEY = "terraultima_run_v1"
    private val json = Json { ignoreUnknownKeys = true; encodeDefaults = true }

    fun load(then: (Save?) -> Unit) {
        Tg.cloudGet(KEY) { raw ->
            then(raw?.takeIf { it.isNotBlank() }?.let {
                runCatching { json.decodeFromString<Save>(it) }.getOrNull()
            })
        }
    }

    fun save(s: Save) = Tg.cloudSet(KEY, json.encodeToString(Save.serializer(), s))

    fun clear() = Tg.cloudRemove(KEY)
}
